import { render, staticRenderFns } from "./EventosCardSuporte.vue?vue&type=template&id=2aca14fd"
import script from "./EventosCardSuporte.vue?vue&type=script&lang=ts"
export * from "./EventosCardSuporte.vue?vue&type=script&lang=ts"
import style0 from "./EventosCardSuporte.vue?vue&type=style&index=0&id=2aca14fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports